// extracted by mini-css-extract-plugin
module.exports = {"footerSize":"Ad_footerSize__1S2LV"};